import { Box, Typography, Card, CardContent } from '@mui/material';

// Karte eines eigenen Trainingsplans in der Übersicht.
function TrainingsplanCard({ plan, onSelect }) {
    return (
        <Card
            sx={{
                mb: 2,
                bgcolor: 'background.paper',
                border: '1px solid',
                borderColor: 'divider',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                '&:hover': {
                    borderColor: 'primary.main',
                    boxShadow: '0 8px 24px rgba(102, 126, 234, 0.2)',
                    transform: 'translateY(-2px)',
                },
            }}
            onClick={onSelect}
        >
            <CardContent sx={{ p: { xs: 2, sm: 3 } }}>
                <Box display="flex" justifyContent="space-between" alignItems="start">
                    <Box flex={1}>
                        <Typography variant="h6" sx={{ fontSize: { xs: '1rem', sm: '1.25rem' } }}>
                            {plan.name}
                        </Typography>
                        <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                            {plan.beschreibung}
                        </Typography>
                        <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 1 }}>
                            Erstellt: {new Date(plan.erstellt_am).toLocaleDateString('de-DE')}
                        </Typography>
                    </Box>
                </Box>
            </CardContent>
        </Card>
    );
}

export default TrainingsplanCard;
